import { SecurityGroupsAction, SecurityGroupsActionType } from './action-types';
import type { ISecurityGroupsState } from './types';

export const securityGroupsReducerName = 'securityGroupsReducer';

export const securityGroupsInitialState: ISecurityGroupsState = {
    groups: null,
    isLoading: false,
    hasError: false,
    errorMessage: null,
};

export function securityGroupsReducer(
    prev: ISecurityGroupsState = securityGroupsInitialState,
    action: SecurityGroupsAction
): ISecurityGroupsState {
    switch (action.type) {
        case SecurityGroupsActionType.REQUEST_SECURITY_GROUPS:
            return { ...prev, isLoading: true, hasError: false, errorMessage: null, groups: null };

        case SecurityGroupsActionType.RECEIVE_SECURITY_GROUPS:
            return { ...prev, isLoading: false, hasError: false, groups: action.groups };

        case SecurityGroupsActionType.ERROR_SECURITY_GROUPS:
            return { ...prev, isLoading: false, hasError: true, errorMessage: action.errorMessage ?? null, groups: [] };

        default:
            return prev;
    }
}
